import { SecurityLevelBase } from './base/security-level-base';

export class SecurityLevel extends SecurityLevelBase { }